import { createContext } from "react";

const AssignBusContext = createContext();

export default AssignBusContext;